import React from "react"
import {
    Card,
    CardBody,
    Row,
    Col,
} from "reactstrap";
import moment from 'moment';
import { Link } from "react-router-dom";

class PersonalInformation extends React.Component {

    render() {
        
        const {
            client
        } = this.props;

        return (
            <Card>
                <CardBody>
                <Row>
                    <Col sm="6">
                    <div className="typography-line">
                        <h4>
                        <span>ID</span>
                        {client._id}
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>First Name</span>
                        {client.first_name || "N/A"}
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>Last Name</span>
                        {client.last_name || "N/A"}
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>Middle Name</span>
                        {client.middle_name || "N/A"}
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>Civil Status</span>
                        {client.civil_status || "N/A"}
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>Age</span>
                        {client.age || "N/A"}
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>Gender</span>
                        {client.gender || "N/A"}
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>Birthday</span>
                        {client.birthday
                            ? moment(client.birthday).format(
                                "MM/DD/YYYY"
                            )
                            : "N/A"}
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>Nationality</span>
                        {client.nationality || "N/A"}
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>TIN</span>
                        {client.tin || "N/A"}
                        </h4>
                    </div>
                    </Col>
                    <Col sm="6">
                    <div className="typography-line">
                        <h4>
                        <span>Email</span>
                        {client.email || "N/A"}
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>Phone</span>
                        {client.phone || "N/A"}
                        </h4>
                    </div>
                    <div className="typography-line">
                            <h4>
                            <span>Seller</span>
                            {client.seller ? 
                                <Link to={`/seller?id=${client.seller._id}`}>
                                    {`${client.seller.first_name} ${client.seller.last_name} (${client.seller.broker.name})`}
                                </Link>
                             : "N/A"
                            }
                            </h4>
                        
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>Project</span>
                        {client.project ? 
                            <Link to={`/project?id=${client.project._id}`}>
                                {client.project.name}
                            </Link>
                        : 
                            "N/A"
                        }
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>Address</span>
                        {client.address || "N/A"}
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>Status</span>
                        {client.status || "N/A"}
                        </h4>
                    </div>
                    {client.status === "Canceled" ? (
                        <div className="typography-line">
                        <h4>
                            <span>Refund Amount</span>
                            {client.refund_amount || "N/A"}
                        </h4>
                        </div>
                    ) : null}
                    <div className="typography-line">
                        <h4>
                        <span>Home Owner</span>
                        {client.home_owner || "N/A"}
                        </h4>
                    </div>
                    {client.home_owner === "Yes" ? (
                        <div className="typography-line">
                        <h4>
                            <span>Owned Date</span>
                            {client.owned_date
                            ? moment(
                                client.owned_date
                                ).format("YYYY-MM-DD")
                            : "N/A"}
                        </h4>
                        </div>
                    ) : null}
                    <div className="typography-line">
                        <h4>
                        <span>RTO Client</span>
                        {client.is_rto ? "Yes" : "No"}
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>Created At</span>
                        {client.created_at
                            ? moment(client.created_at).format(
                                "YYYY-MM-DD HH:mm:ss"
                            )
                            : "N/A"}
                        </h4>
                    </div>
                    <div className="typography-line">
                        <h4>
                        <span>Updated At</span>
                        {client.updated_at
                            ? moment(client.updated_at).format(
                                "YYYY-MM-DD HH:mm:ss"
                            )
                            : "N/A"}
                        </h4>
                    </div>
                    </Col>
                </Row>
            </CardBody>
          </Card>
        )
    }
}

export default PersonalInformation;